// extracted by mini-css-extract-plugin
module.exports = {"card":"ReviewCard_card__3sd9Y","details":"ReviewCard_details__16IBr"};